import { ReferenceTables } from 'components/ReferenceTables';
import { Page } from 'layouts/Page';

export const ReferenceTablesPage = () => {
	return (
		<Page title="Reference Tables – EAS Control Center">
			<ReferenceTables />
		</Page>
	);
};
